import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Importa useLocation
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col,  Tab, Tabs} from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";
import { FloatCardComponent, MisPagosGiraComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import {getGira, cuotasAlumno, getDocumentosGira, getAlumno, updateAlumno} from "../../api/giras.ts";
import {getGeneros, tipoAlimentacion, tipoSangre, tallaPolera} from "../../api/mantenedores.ts";
import Swal from 'sweetalert2';
import { useAuthStore } from "../../store/auth.store.ts";

export default function MiGiraViewPage() {

    const { t } = useContext(TranslatorContext)

    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    const [usuario, setUsuario] = useState({});
     const [rut, setRut] = useState("");

    const location = useLocation();


    const [giraData, setGiraData] = useState([]);
    const [cuotas, setCuotas] = useState([]);
    const [idAlumno, setIdAdlumno] = useState(null);
    const [totalGira, setTotalGira] = useState(0);
    const [totalPagado, setTotalPagado] = useState(0);
    const [totalPagadoMultas, setTotalPagadoMultas] = useState(0);
    const [documentos, setDocumentos] = useState([]);
    const [alumnoData, setAlumnoData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [generos, setGeneros] = useState([]);
    const [tipoAlimentacionData, setTipoAlimentacionData] = useState([]);
    const [tipoSangreData, setTipoSangreData] = useState([]);
    const [tallaPoleraData, setTallaPoleraData] = useState([]);


     const floats = [
        { "title": "total por pagar", "digit": "$"+totalGira?.toLocaleString('es-CL'), "icon": "shopping_cart", "variant": "sm pink" }, 
        { "title": "pendiente de pago", "digit": "$"+(totalGira - totalPagado)?.toLocaleString('es-CL'), "icon": "hotel_class", "variant": "sm blue" },
        { "title": "pagado (Multas pagas: $"+totalPagadoMultas?.toLocaleString('es-CL')+")", "digit": "$"+totalPagado?.toLocaleString('es-CL'), "icon": "shopping_bag", "variant": "sm orange" },

    ]

    useEffect(() => {

                     setUsuario(useAuthStore.getState().usuario);
                     const rut = useAuthStore.getState().usuario.rut;
                     setRut(rut.toLocaleString('es-ES')+'-'+useAuthStore.getState().usuario.dv);

                    const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
                    const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
                    const alumnoId = params.get('alumno'); // Obtén el valor del parámetro 'alumno'
                    setIdAdlumno(alumnoId);        
                    
                    const fetchTabla = async () => {
                      
                        const res = await getGira(giraId);
                      
                        setGiraData(res.gira);

                        const restCuotas = await cuotasAlumno(alumnoId);
                       
                        const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
                        setTotalGira(sumaTotalCuotas);

                        const totalPagado = restCuotas
                            .filter(cuota => cuota.cou_montopagado !== null)
                            .reduce((total, cuota) => total + (Number(cuota.cou_montopagado || 0) - Number(cuota.cou_multa || 0)), 0);
                        // Puedes guardar el total pagado en un estado si lo necesitas:
                        setTotalPagado(totalPagado);

                        const totalPagadoMultas = restCuotas
                            .filter(cuota => cuota.cou_montopagado !== null)
                            .reduce((total, cuota) => total + Number(cuota.cou_multa || 0), 0);
                        // Puedes guardar el total pagado en un estado si lo necesitas:
                        setTotalPagadoMultas(totalPagadoMultas);

                        setCuotas(restCuotas);

                        const resDocumentos = await getDocumentosGira(giraId);
                        setDocumentos(resDocumentos);

                        const restAlumno = await getAlumno(alumnoId);
                        setAlumnoData(restAlumno);

                        const generosData = await getGeneros();
                        setGeneros(generosData.data);
                        console.log("generosData", generos);

                        const tipoAlimentacionData = await tipoAlimentacion();
                        setTipoAlimentacionData(tipoAlimentacionData.data);

                        const tipoSangreData = await tipoSangre();
                        setTipoSangreData(tipoSangreData.data);

                        const tallaPoleraData = await tallaPolera();
                        setTallaPoleraData(tallaPoleraData.data);

                    }
        
                    
                    fetchTabla();   
                   
                }, []);
    const handleOpenEditModal = () => {
        setEditData(alumnoData || {});
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => setShowEditModal(false);

    const handleEditChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleSaveEdit = async () => {
        const camposRequeridos = [
        { key: "idgenero", label: "Género" },
        { key: "idalimentacion", label: "Tipo Alimentación" },
        { key: "idsangre", label: "Tipo Sangre" },
        { key: "idpolera", label: "Talla Polera" },
        { key: "alu_alergia", label: "Alergía" },
        { key: "alu_enfermedad", label: "Enfermedad Preexistente" },
        { key: "alu_tratamiento", label: "Tratamiento" }
    ];

    // Busca campos vacíos
    const vacios = camposRequeridos.filter(campo => !editData[campo.key] || editData[campo.key].toString().trim() === "");

    if (vacios.length > 0) {
        Swal.fire({
            icon: 'warning',
            text: `Debes completar: ${vacios.map(v => v.label).join(', ')}`
        });
        return;
    }

    
        // Aquí deberías llamar a tu API para guardar los cambios
         updateAlumno(editData).then(async res => {
                       Swal.close();
                    //  fetchTabla();
                       if (res.error === false) {
                          const restAlumno = await getAlumno(editData.alu_id);
                          setAlumnoData(restAlumno);
                           setShowEditModal(false);
                             
                         Swal.fire({
                           icon: 'success',
                           text: 'Alumno editada correctamente.'
                         })
                         
                       }
                       else {
                         let errorMsg = res.msg;
                         if (res.errores) {
                           errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
                           res.errores.forEach(error => {
                             errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
                           });
                           errorMsg += '</tbody></table>';
                         }
             
                         Swal.fire({
                           icon: 'error',
                         
                           html: errorMsg
                         })
                       }
             
                     });
        console.log("Datos editados:", editData);
        //setAlumnoData(editData); // Actualiza el estado local
       
    };            
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Gira de Estudio</h3>
                            <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={5}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Mi Gira</h4>
                            
                        </div>
                        <div className="mc-user-group">
                            <div className="mc-user-profile">
                                <div className="mc-round-avatar md">
                                    <img src="images/LogoEmail.png" alt="avatar" />
                                </div>
                                <div className="mc-duel-text md">
                                    <h3 className="mc-duel-text-title">{giraData.est_nombre} - CURSO: {giraData.gir_curso}</h3>
                                    <p className="mc-duel-text-descrip"></p>
                                </div>
                            </div>
                            <div className="mb-4">
                                <h6 className="mc-divide-title mb-4">Información</h6>
                                <ul className="mc-user-metalist">
                                <li><i className="material-icons">map</i><span>Programa: {giraData.programa}</span></li>
                                <li><i className="material-icons">map</i><span>Tramo: {giraData.tramo}</span></li>
                                <li><i className="material-icons">map</i><span>Liberados: {giraData.gir_liberados}</span></li>
                                <li><i className="material-icons">map</i><span>Curso: {giraData.gir_curso}</span></li>
                                    <li><i className="material-icons">map</i><span>Comuna: {giraData.com_nombre}</span></li>
                                    <li><i className="material-icons">map</i><span>Región: {giraData.reg_nombre}</span></li>
                                    <li><i className="material-icons">map</i><span>Nombre Contacto: {giraData.gir_contacto}</span></li>
                                     <li><i className="material-icons">map</i><span>Celular Contacto: {giraData.gir_celcontacto}</span></li>
                                    <li><i className="material-icons">map</i><span>Email Contacto: {giraData.gir_emailcontacto}</span></li>
                                   
                                </ul>
                            </div>
                           
                            
                           
                        </div>
                        
                         <div className="mc-user-group">

                        <Tabs defaultActiveKey="pasajero" id="mc" className="mc-tabs">
                            <Tab eventKey="pasajero" title="Información Pasajero" className="mc-tabpane pasajero">
                                <div className="mc-card-header">
                           
                                    <button type='button'  onClick={handleOpenEditModal} className='mc-dropdown-menu'><i className='material-icons'>edit</i><span>Editar Datos del Pasajero</span></button>
                                
                                </div>
                               <div className="mb-4">
                                <h6 className="mc-divide-title mb-4">Información Pasajero</h6>
                                <ul className="mc-user-metalist">
                                <li><i className="material-icons">map</i><span>Nombre: {alumnoData?.alu_nombres} </span></li>
                                <li><i className="material-icons">map</i><span>Apellidos: {alumnoData?.alu_apellidos}</span></li>
                                <li><i className="material-icons">map</i><span>RUT: {alumnoData?.alu_rut.toLocaleString('es-ES')}-{alumnoData?.alu_dv}</span></li>
                                <li><i className="material-icons">map</i><span>Fecha Nacimiento: {alumnoData?.alu_fnacimiento}</span></li>
                               
                                    <li><i className="material-icons">map</i><span>Calidad: {alumnoData?.calidad}</span></li>
                                    <li><i className="material-icons">map</i><span>Nacionalidad:{alumnoData?.alu_nacionalidad || "Sin Información"}</span></li>
                                    
                                     <li><i className="material-icons">map</i><span>Genero: {alumnoData?.genero || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Alergia: {alumnoData?.alu_alergia || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Tipo Alimentación: {alumnoData?.alimientacion || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Tipo Sangre: {alumnoData?.sangre || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Enfermedad Preexistente: {alumnoData?.alu_enfermedad || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Tratamiento: {alumnoData?.alu_tratamiento || "Sin Información"}</span></li>
                                    <li><i className="material-icons">map</i><span>Talla Polera:  {alumnoData?.polera || "Sin Información"}</span></li>
                                   
                                </ul>
                            </div>
                            </Tab>
                            <Tab eventKey="responsable" title="Información Responsable" className="mc-tabpane responsable">
                                <div className="mb-4">
                                <h6 className="mc-divide-title mb-4">Información Responsable</h6>
                                <ul className="mc-user-metalist">
                                <li><i className="material-icons">map</i><span>Nombre: {usuario.nombre} </span></li>
                                <li><i className="material-icons">map</i><span>Apellidos: {usuario.apellido}</span></li>
                                <li><i className="material-icons">map</i><span>RUT: {rut}</span></li>
                                <li><i className="material-icons">map</i><span>Email: {usuario.email}</span></li>
                               
                                  
                                   
                                </ul>
                            </div>
                            </Tab>
                        </Tabs>
                            
                            
                           
                        </div>
                    </div>
                </Col>
                <Col xl={7}>
                    <Row>
                        {floats.map((float, index) => (
                            <Col md={4} lg={4} key={ index }>
                                <FloatCardComponent 
                                    variant={ float.variant }
                                    digit={ float.digit }
                                    title={ float.title }
                                    icon={ float.icon }
                                />
                            </Col>
                        ))}
                        <Col xl={12}> 
                            <MisPagosGiraComponent cuotas={cuotas} gira={giraData} docsGira={documentos} /> 
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Modal show={showEditModal} onHide={handleCloseEditModal} >
                 <div className="mc-alert-modal" style={{width: '1300px'}}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Datos del Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Genero</Form.Label>
                            <Form.Select
            name="idgenero"
            value={editData.idgenero || ""}
            onChange={handleEditChange}
        >
            <option value="">Seleccionar</option>
            {generos?.map((g) => (
                <option key={g.id} value={g.id}>{g.nombre}</option>
            ))}
        </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Alergía</Form.Label>
                            <Form.Control
                                type="text"
                                name="alu_alergia"
                                value={editData.alu_alergia || ""}
                                onChange={handleEditChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Tipo Alimentación</Form.Label>
                             <Form.Select
                                    name="idalimentacion"
                                    value={editData.idalimentacion || ""}
                                    onChange={handleEditChange}
                                >
                                    <option value="">Seleccionar</option>
                                    {tipoAlimentacionData.map((a) => (
                                        <option key={a.id} value={a.id}>{a.nombre}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Tipo Sangre</Form.Label>
                            <Form.Select
                                    name="idsangre"
                                    value={editData.idsangre || ""}
                                    onChange={handleEditChange}
                                >
                                    <option value="">Seleccionar</option>
                                    {tipoSangreData.map((s) => (
                                        <option key={s.id} value={s.id}>{s.nombre}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                         <Form.Group>
                            <Form.Label>Enfermedad Preexistente</Form.Label>
                            <Form.Control
                                type="text"
                                name="alu_enfermedad"
                                value={editData.alu_enfermedad || ""}
                                onChange={handleEditChange}
                            />
                        </Form.Group>
                         <Form.Group>
                            <Form.Label>Tratamiento</Form.Label>
                            <Form.Control
                                type="text"
                                name="alu_tratamiento"
                                value={editData.alu_tratamiento || ""}
                                onChange={handleEditChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Talla Polera</Form.Label>
                            <Form.Select
                                    name="idpolera"
                                    value={editData.idpolera || ""}
                                    onChange={handleEditChange}
                                >
                                    <option value="">Seleccionar</option>
                                    {tallaPoleraData.map((t) => (
                                        <option key={t.id} value={t.id}>{t.nombre}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                        {/* Agrega más campos según lo que quieras editar */}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveEdit}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
                </div>
            </Modal>
        </PageLayout>
    )
}